import { getCdn } from "utils";
import appConfig from "config.json";
import { loadBrandParam, urlParams } from "utils/paramsValidation";

let customTheme = false;
let bodyMutationObserver;
let themeLoaderTimeout = null;

const timeoutDuration = 1000;
const brand = loadBrandParam();
const { brands, globalThemes, lowPriorityThemes, highPriorityThemes } =
	appConfig;
const cdnThemes = brands[brand].cdnThemes || [];
const allowedThemes = globalThemes
	.concat(brands[brand].themes || [])
	.concat(cdnThemes);

const applyLoadedThemeClass = () => {
	if (!document?.body.classList.contains("theme-loaded")) {
		document?.body.classList.add("theme-loaded");
	}
	if (themeLoaderTimeout) {
		clearTimeout(themeLoaderTimeout);
		themeLoaderTimeout = null;
	}
};

const loadThemeCss = (theme) => {
	const isCdnTheme = cdnThemes.includes(theme);
	const fileName = `${getCdn(isCdnTheme)}/themes/${
		isCdnTheme ? `${theme}/` : ""
	}${theme}.min.css`;
	if (!document?.querySelector('link[href="' + fileName + '"]')) {
		const link = document?.createElement("link");
		link.type = "text/css";
		link.rel = "stylesheet";
		link.href = fileName;
		link.onload = applyLoadedThemeClass;
		link.onerror = applyLoadedThemeClass;
		document?.head.appendChild(link);
	}
	if (highPriorityThemes.includes(theme)) {
		document?.body.classList.add("disableCustomNavigationTheme");
	}
};

const findThemeInClassesList = (setNewConfig) => {
	const classes = document?.body.classList;
	for (let index = 0; index < allowedThemes.length; index++) {
		if (classes.contains(allowedThemes[index])) {
			setNewConfig("theme", allowedThemes[index]);
			loadExternalThemeStyles(allowedThemes[index]);
			return true;
		}
	}
	return false;
};

const extractThemeFromBodyClasses = (setNewConfig) => {
	const theme = findThemeInClassesList(setNewConfig);
	if (!theme && !bodyMutationObserver) {
		bodyMutationObserver = new MutationObserver(() => {
			findThemeInClassesList(setNewConfig);
		});
		bodyMutationObserver.observe(document?.body, {
			attributeFilter: ["class"],
		});
	}
};

const loadTheme = (setNewConfig) => {
	const theme = urlParams.get("theme") || "";
	if (theme) {
		loadExternalThemeStyles(theme);
		setNewConfig("theme", theme);
	} else {
		extractThemeFromBodyClasses(setNewConfig);
	}
	if (!themeLoaderTimeout) {
		themeLoaderTimeout = setTimeout(
			() => applyLoadedThemeClass(),
			timeoutDuration
		);
	}
};

export const loadExternalThemeStyles = (theme) => {
	if (theme && allowedThemes.includes(theme)) {
		if (customTheme && lowPriorityThemes.includes(theme)) return;
		loadThemeCss(theme);
	}
};

export const loadThemeConfigurations = (setNewConfig) => {
	loadTheme(setNewConfig);
};

export const preloadThemeCss = (theme) => {
	if (!theme || !allowedThemes.includes(theme)) return;
	loadThemeCss(theme);
};
